import React, { useState } from 'react';
import '../../../entrydoor.css';

const GlassDividersHorizontal = ({ value, onChange, label = 'Horizontal:', disabled = false }) => {
    const [selectedGlassDividersHorizontal, setSelectedGlassDividersHorizontal] = useState(value || "");
     const [GlassDividersHorizontalError, setGlassDividersHorizontalError] = useState("");

    const handleGlassDividersHorizontalChange = (e) => {
        //setSelectedGlassDividersHorizontal(e.target.value);
        validateGlassDividersHorizontal(e.target.value);
        onChange(e.target.value);
    };
    const validateGlassDividersHorizontal = (value) => {
        const numericValue = value.replace(/\D/g, ""); // Allow only numbers
        setSelectedGlassDividersHorizontal(numericValue);
      
        if (numericValue && (numericValue < 0 || numericValue > 10)) {
            setGlassDividersHorizontalError('must be between 0" and 10"');
        } else {
            setGlassDividersHorizontalError("");
        }
    };
    return (
        <div className="a-container">
            <label style={{ display: "none" }} disabled={disabled} htmlFor="GlassDividersHorizontal">{label}</label>
            <input style={{ display: "none" }}
                disabled={disabled}
                id="GlassDividersHorizontal"
                value={selectedGlassDividersHorizontal}
                onChange={handleGlassDividersHorizontalChange}
            >
            </input>
            {GlassDividersHorizontalError && <p className="error">{GlassDividersHorizontalError}</p>}
        </div>
    );
};

export default GlassDividersHorizontal;
